import { MapLocation, MapMarkerData } from "data/map/MapLink";

export function getLocationsFromMapMarkers(markers: MapMarkerData[]): MapLocation[] {
  return markers.map<MapLocation>(marker => {
    return { lat: marker.location().lat, lng: marker.location().lng };
  });
}
